
import { inAppRedirect, appURLs } from '~/utils/route-redirects';

export default {
  name: 'NotificationAddedToPortfolio',
  props: {
    notif: {
      required: true,
      type: Object,
    },
  },
  methods: {
    goToTarget(targetId) {
      inAppRedirect(
        this.localePath({
          name: appURLs.messages(),
          query: { profileId: targetId },
        })
      );
    },
  },
};
